import React, { useState, useEffect } from 'react';
import '../CreateProduct.css';
import {
    makeStyles, Paper
} from '@material-ui/core';
import clsx from 'clsx';
import CustomAlert from '../../CustomAlert';
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import { Helmet } from 'react-helmet';
import { getProductDocumentWithUserId } from '../../../Backend/firebase/product';
import { RATE_LIST } from '../../../mock';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
        padding: '20px'
    },
}));

function RateList() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const [openNotify, setOpenNotify] = React.useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [MedicineEntry, setMedicineEntry] = useState(null)
    const [medicineRateList, setMedicineRateList] = useState([])
    const { userData } = CheckUserProvider();

    const parseExcelData = () => {
        const headers = ["Particulars", "MRP", "Rate", "Tax", "Discount", "Net Rate"];
        
        // Split rows by newline
        const rows = RATE_LIST.trim().split("\n");
        
        // Map rows to objects
        return rows.map(row => {
          const values = row.split("\t");
          return headers.reduce((obj, header, index) => {
            obj[header] = values[index] ? isNaN(values[index]) ? values[index] : parseFloat(values[index]) : null;
            return obj;
          }, {});
        });
      }

    useEffect(async () => {
        if (userData) {
            try {
                const getRateList = parseExcelData();
                setMedicineRateList(getRateList);
            } catch (error) {
                console.log('Error Occur in Get Products And Sales', error)
            }
        }
    }, [userData])

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        console.log('handleOnSearch')
    }

    const handleOnHover = (result) => {
        // the item hovered
        console.log('handleOnHover')
    }

    const handleOnSelect = (item) => {
        // the item selected
        console.log('handleOnSelect', item)
        setMedicineEntry(item)
    }

    const handleOnFocus = () => {
        console.log('Focused')
    }

    const formatResult = (item) => {
        return (
            <>
                <span style={{ display: 'block', textAlign: 'left' }}>
                    {item.Particulars}
                </span>
            </>
        )
    }


    return (
        <>
            <div className="createProduct rate-list mt-2">
                <Helmet>
                    <meta name="description" content="Creating New Product And Sales page." />
                    <title>Medicine Rate List | Kaipsool Pharmatech</title>
                </Helmet>
                <Paper className={fixedHeightPaper}>
                    <div className="row">
                        <h5 className="mt-3 text-center">Rate List for Chemist &nbsp; </h5>
                        <div className="row mb-3">
                            <div className="col-md-2 mb-2"></div>
                            <div className="col-md-8 mb-2">
                                <ReactSearchAutocomplete
                                    items={medicineRateList}
                                    placeholder="Search Medicine..."
                                    fuseOptions={{ keys: ['Particulars'] }}
                                    resultStringKeyName="Particulars"
                                    onSearch={handleOnSearch}
                                    onHover={handleOnHover}
                                    onSelect={handleOnSelect}
                                    onFocus={handleOnFocus}
                                    autoFocus
                                    formatResult={formatResult}
                                    styling={{
                                        borderRadius: '8px',
                                        zIndex: 1000,
                                    }}
                                />
                            </div>
                            <div className="col-md-2 mb-2"></div>
                        </div>

                        {(MedicineEntry && MedicineEntry != null) && (<div className="row mb-3 ml-5 table-overflow">
                            <h6>Search Result:</h6>
                            <table className="table">
                                <thead>
                                    <td><b>Particulars</b></td>
                                    <td><b>MRP</b></td>
                                    <td><b>Rate</b></td>
                                    <td><b>Tax</b></td>
                                    <td><b>Discount</b></td>
                                    <td><b>Net Rate</b></td>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{MedicineEntry?.Particulars}</td>
                                        <td>{MedicineEntry?.MRP}</td>
                                        <td>{MedicineEntry?.Rate}</td>
                                        <td>{MedicineEntry?.Tax}</td>
                                        <td>{MedicineEntry?.Discount}</td>
                                        <td>{MedicineEntry["Net Rate"]}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>)}
                    </div>
                </Paper>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default RateList

